import React, { PureComponent } from 'react';
import styled from 'styled-components';
import i18next from 'i18next';

// Components
import { SelectField } from 'components/Fields';

// Styles & images
import CampusIcon from 'src/assets/images/campus-icon.svg';

const ValueItemWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5em;
  p {
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
    padding-left: 0.8em;
  }
`;

const CampusesSelectWrapper = styled.div`
  .rw-list-option {
    padding: 1em;
    &:first-of-type {
      position: relative;
      &:after {
        display: ${p => (p.hideFirstElBorder ? 'none' : 'block')};
        width: 100%;
        height: 1px;
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        background: ${props => props.theme.color.border};
      }
    }
  }
  .rw-popup ul {
    max-height: inherit;
  }
  ${p =>
    p.disabled &&
    ` pointer-events: none;
      .rw-widget-input {
        background: ${p.theme.color.background};
        > *{
          opacity: .5;
        }
      }
   `};
`;

const allAvailableCampuses = {
  name: i18next.t('all_available_location'),
  id: null
};

const renderValueItem = ({ item }) => {
  return (
    <ValueItemWrapper>
      <img src={CampusIcon} alt={item && item.name} />
      <p>{item && item.name}</p>
    </ValueItemWrapper>
  );
};

class CampusesSelect extends PureComponent {
  render() {
    const { campuses, disabled, onChangeCampus, selectedCampusId, excludeAllLocales } = this.props;
    const sortList =
      Array.isArray(campuses) && campuses.length
        ? campuses.slice().sort((a, b) => (a.name < b.name ? -1 : 1))
        : null;
    // add all available functionality
    if (
      sortList &&
      !excludeAllLocales &&
      !sortList.find(_c => String(_c.id) === String(allAvailableCampuses.id))
    ) {
      sortList.unshift(allAvailableCampuses);
    }
    // set value
    let value = (value =
      (Array.isArray(sortList) &&
        selectedCampusId &&
        sortList.find(c => String(c.id) === String(selectedCampusId))) ||
      (Array.isArray(sortList) && sortList[0]));

    return sortList && sortList.length ? (
      <CampusesSelectWrapper disabled={disabled} hideFirstElBorder={excludeAllLocales}>
        <SelectField
          data={sortList}
          textField="name"
          valueField="id"
          value={value}
          valueComponent={renderValueItem}
          onChange={onChangeCampus}
        />
      </CampusesSelectWrapper>
    ) : null;
  }
}

export default CampusesSelect;
